// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lWIXw_ktoeItSrUa6yLT {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.IHRz5MGh_eVi8q7Ib1cU {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/CampaignOnlyLayouts/styles/CampaignOnlyLayout.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".campaignOnlyContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.contentContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignOnlyContainer": `lWIXw_ktoeItSrUa6yLT`,
	"contentContainer": `IHRz5MGh_eVi8q7Ib1cU`
};
export default ___CSS_LOADER_EXPORT___;
